module.exports = __webpack_public_path__ + "assets/img/carding.ef0aed10.png";